
import React from 'react';
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';

interface BillingCycleSelectorProps {
  billingCycle: 'monthly' | 'quarterly' | 'yearly';
  onSelectBillingCycle: (cycle: 'monthly' | 'quarterly' | 'yearly') => void;
}

const BillingCycleSelector: React.FC<BillingCycleSelectorProps> = ({
  billingCycle,
  onSelectBillingCycle
}) => {
  const handleBillingCycleChange = (value: string) => {
    onSelectBillingCycle(value as 'monthly' | 'quarterly' | 'yearly');
  };

  return (
    <Tabs value={billingCycle} className="w-full">
      <TabsList className="grid w-full grid-cols-3">
        <TabsTrigger 
          value="monthly" 
          onClick={() => handleBillingCycleChange("monthly")}
        >
          Monthly
        </TabsTrigger>
        <TabsTrigger 
          value="quarterly" 
          onClick={() => handleBillingCycleChange("quarterly")}
        >
          Quarterly
        </TabsTrigger>
        <TabsTrigger 
          value="yearly" 
          onClick={() => handleBillingCycleChange("yearly")}
        >
          Yearly
        </TabsTrigger>
      </TabsList>
    </Tabs>
  );
};

export default BillingCycleSelector;
